import axios from "axios";
import { SERVER_URL } from "../config";
import { history } from "../helpers";
import { authHeader, handleError } from "../helpers";

let baseRoute = SERVER_URL;

export const supportService = {
    getTicketsList,
    getTicketDetails,
    acceptTicket,
    addMessageTicket,
    closeTicket,
};

function getTicketsList(status) {
    console.log("into supportService (getTicketsList)");
    return axios
        .get(`${baseRoute}/support/ticket/list/${status}`, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

function getTicketPriority() {
    console.log("into supportService (getTicketPriority)");
    return axios
        .get(`${baseRoute}/support/ticket/priority`, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}


function getTicketType() {
    console.log("into supportService (getTicketType)");
    return axios
        .get(`${baseRoute}/support/ticket/type`, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

function getTicketDetails(ticketId) {
    console.log("into supportService (getTicketDetails)");
    return axios
        .get(`${baseRoute}/support/ticket/details/${ticketId}`, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

function acceptTicket(params) {
    console.log("into supportService (acceptTicket)");
    return axios
        .put(`${baseRoute}/support/ticket/accept`, params, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

function addMessageTicket(form) {
    console.log("into supportService (acceptTicket)");
    return axios
        .put(`${baseRoute}/support/ticket/message/add`, form, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

function closeTicket(params) {
    console.log("into supportService (acceptTicket)");
    return axios
        .put(`${baseRoute}/support/ticket/close`, params, { headers: authHeader() })
        .then((res) => {
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                handleError(error.response.status);
            }
        });
}

